<template>
  <div class="p-terms">
    <p class="p-terms__close" @click="handleToggleAccordion">
      {{ AccordionText }}
      <img :src="IconChevronDown">
    </p>
    <div class="p-terms__item">
      <div class="p-terms__inner page-type">
        <p class="p-terms__name">
          {{ $t('pages.companies.analysis.crossSearch.primaryType') }}:
        </p>
        <Select v-model="innerCurrentPageType" :options="pageTypeSelectOptions" :disabled="disabled" />
      </div>
    </div>
    <transition name="accordion">
      <div v-show="isAccordionOpen" class="p-terms__item accordion">
        <div class="p-terms__inner">
          <p class="p-terms__name">
            {{ $t('pages.companies.analysis.crossSearch.addDimension') }}:
          </p>
          <ul class="p-terms__radio c-radio">
            <li v-for="type in pageTypes" :key="type.id" class="c-radio__item" :class="{ 'u-hidden': type.id === currentPageType.id }">
              <input :id="'checkbox_'+type.id"
                     v-model="innerCrossSearchField"
                     class="c-radio__input js-companiesAnalysisReviews__crossButton"
                     type="radio"
                     :value="type"
                     :disabled="disabled"
              >
              <label class="c-radio__label" :for="'checkbox_' + type.id">{{ type.name }}</label>
            </li>
          </ul>
          <p class="p-terms__clear">
            <button @click="setCrossSearchField(null)">
              {{ $t('pages.companies.analysis.crossSearch.reset') }}
            </button>
          </p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import IconChevronDown from '../../../../images/common/icon_chevron_down.svg'
import Select from '../Select'
import { actionEvent } from 'src/biz_spa/modules/googleAnalytics'

export default {
  name: 'CompaniesAnalysisCrossSearch',
  components: {
    Select,
  },
  props: {
    disabled: {
      type: Boolean,
      required: true,
    },
    currentPageType: {
      type: Object,
      required: true,
    },
    pageTypes: {
      type: Array,
      required: true,
    },
    crossSearchField: {
      type: Object,
    }
  },
  emits: ['set-page-type', 'set-cross-search-field'],
  data() {
    return {
      isAccordionOpen: false,
      selectPageType: this.currentPageType.name,
    }
  },
  computed: {
    IconChevronDown: () => IconChevronDown,
    AccordionText() {
      return this.isAccordionOpen ? this.$t('pages.companies.analysis.crossSearch.close') : this.$t('pages.companies.analysis.crossSearch.open')
    },
    pageTypeSelectOptions() {
      return this.pageTypes.filter(p => p.fields !== this.crossSearchField?.fields).map(p => p.name)
    },
    innerCurrentPageType: {
      get() {
        return this.currentPageType.name
      },
      set(value) {
        const pageType = this.pageTypes.find(i => i.name === value)
        this.$emit('set-page-type', pageType)
        if (this.$route.path.includes('analysis/reviews')) {
          actionEvent('RevAnalAxis')
        }
      }
    },
    innerCrossSearchField: {
      get() {
        return this.crossSearchField
      },
      set(value) {
        this.$emit('set-cross-search-field', value)
        if (this.$route.path.includes('analysis/reviews')) {
          switch (value.fields) {
          case 'store_id':
            actionEvent('byStore')
            break
          case 'site_type':
            actionEvent('bySite')
            break
          case 'brand_id':
            actionEvent('byBrand')
            break
          case 'locale':
            actionEvent('byLocale')
            break
          case 'franchisee_id':
            actionEvent('byFranchisee')
            break
          case 'user_company_id':
            actionEvent('byAreaMgr')
            break
          case 'prefecture':
            actionEvent('byPrefecture')
            break
          case 'area_id':
            actionEvent('byLocation')
            break
          case 'original_tag_group_a_tag_id':
            actionEvent('byTagA')
            break
          case 'original_tag_group_b_tag_id':
            actionEvent('byTagB')
            break
          case 'original_tag_group_c_tag_id':
            actionEvent('byTagC')
            break
          case 'original_tag_group_d_tag_id':
            actionEvent('byTagD')
            break
          case 'original_tag_group_e_tag_id':
            actionEvent('byTagE')
            break
          }
        }
      }
    },
  },
  methods: {
    setCrossSearchField(value) {
      this.$emit('set-cross-search-field', value)
    },
    handleToggleAccordion() {
      this.isAccordionOpen = !this.isAccordionOpen
      if (this.$route.path.includes('analysis/reviews')) {
        actionEvent('RevAnalPanel')
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.p-terms {
  margin-bottom: 32px;
}

.page-type {
  display: flex;
  align-items: center;

  @media screen and (max-width: 768px) {
    margin-top: 32px;
  }

  .c-select {
    margin: 0 0 0 16px;
  }
}

.accordion {
  margin-top: 16px;
}

.accordion-enter-active, .accordion-leave-active {
  transition: all .3s ease;
}
.accordion-enter-from, .accordion-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
.p-terms__radio {
  margin: 0;
  max-width: 63%;
  .c-radio__item {
    padding: 0 12px;
  }
}
</style>
